import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasLangs)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langs[_ctx.repoFullName], (val, lang) => {
          return (_openBlock(), _createElementBlock("div", {
            key: lang,
            style: _normalizeStyle({
        width: _ctx.calculatePercentage(val) + '%',
        backgroundColor: _ctx.colors[lang] || '#999',
      })
          }, _toDisplayString(_ctx.calculatePercentage(val) > 5 ? _ctx.calculatePercentage(val) + '%' : ''), 5))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}